<template>
<div class="chapter">
<div class="inner_page">
<p class="dedication"><a id="page-v"></a><em>At last, this one is for David Wingrove, Steadfast friend, Ace writer</em></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?74361b37